






























































































































































































































import {Component, Watch, Mixins} from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import PageTitle from '@/components/common/PageTitle.vue';
import GridsColums from '@/components/common/statistic/mixins/GridsColums';
import PeriodDateCalendar from '@/components/common/datepicker/PeriodDateCalendar.vue';
import ItemTable from '@/components/common/ItemTable.vue';
import TuiGrid from 'tui-grid';
import {getCookie, setCookie} from '@/utils/cookieUtils';
import { GetStatisticsExcelRequest, Mall } from 'supporter';
import {i18nInObjectList} from '@/utils/i18n';
import {getFirstAndEndDay, getToday, addMonth, changeDateFormat} from '@/utils/dateUtils';
import {createExcel} from '@/components/common/grid/ExcelCreateUtil';
import ExcelCreateButton from '@/components/common/grid/ExcelCreateButton.vue';
import { ValueNameType } from '@/store/modules/orderEnums';

const orderEnumsModule = namespace('orderEnums');
const mallModule = namespace('mall');

@Component({
  components: {
    PageTitle,
    PeriodDateCalendar,
    ItemTable,
    ExcelCreateButton
  }
})
export default class SalesPeriod extends Mixins(GridsColums) {
  @mallModule.Getter('mallsGlobal')
  private mallsArr!: Mall[];
  @orderEnumsModule.Getter('payTypeMap')
  private readonly payTypeMap!: ValueNameType[];

  private startYmdt: string = addMonth(new Date(), -1);
  private endYmdt: string = getToday();
  private periodOption = {
    periodTypes: ['td', 'ytd', '1w', '1m'],
    period: '1m'
  };

  private theForm = {
    mallNo: this.$store.getters['mall/malls'][0].mallNo,
    memberType: 'ALL',
    genderTypes: ['MALE', 'FEMALE', 'UNKNOWN'],
    memberGradeNo: '0',
    memberGroupNo: '0',
    platformTypes: ['PC', 'MOBILE_WEB', 'MOBILE_APP'],
    includesClaim: false,
    payType: '',
    dateType: 'MONTH',
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1
  };
  private pageSize: number = 100;
  private yearArr: any[] = this.getSelectYears('년');
  private monthArr: any[] = this.getSelectMonths('월');
  private memberGrades: any[] = [];
  private memberGroups: any[] = [];
  private payTypeArr: any[] = [];
  private checkAllGenderTypes: boolean = true;
  private checkAllPlatformTypes: boolean = true;

  private getSelectYears(str: any): object[] {
    const year = new Date().getFullYear();
    const result: object[] = [];
    for (let i = 4; i >= 0; i--) {
      const tempObj = {value: year - i, display: `${year - i}${str}`};
      result.push(tempObj);
    }
    return result;
  }

  private getSelectMonths(str: any): object[] {
    const result: object[] = [];
    for (let i = 1; i <= 12; i++) {
      const tempObj = {value: i, display: `${i}${str}`};
      result.push(tempObj);
    }
    return result;
  }

  @Watch('theForm.genderTypes')
  genderTypesChange() {
    this.checkAllGenderTypes = this.theForm.genderTypes.length === 3;
  }
  checkAllGenderTypesChange() {
    if (this.checkAllGenderTypes) {
      this.theForm.genderTypes = ['MALE', 'FEMALE', 'UNKNOWN'];
    } else {
      this.theForm.genderTypes = [];
    }
  }

  @Watch('theForm.platformTypes')
  platformTypesChange() {
    this.checkAllPlatformTypes = this.theForm.platformTypes.length === 3;
  }
  checkAllPlatformTypesChange() {
    if (this.checkAllPlatformTypes) {
      this.theForm.platformTypes = ['PC', 'MOBILE_WEB', 'MOBILE_APP'];
    } else {
      this.theForm.platformTypes = [];
    }
  }
  private tableOneOptions = {
    showTopcontent: false,
    noBorder: true,
    nonDataBodyHeight: 100,
    haveDataBodyHeight: 35
  };
  private tableTwoOptions = {
    showTopcontent: false,
    noBorder: true,
    nonDataBodyHeight: 100,
    haveDataBodyHeight: 250
  };
  private tableThreeOptions = {
    showTopcontent: true,
    noBorder: true,
    haveExcelDownBtn: false,
    pageSize: 100,
    onLoadSearch: false
  };
  private tableFormLeft: string = '';
  private tableFormRight: string = '';
  private salesStatisticSummaryGridData: any[] = [];
  private salesStatisticPromotionSummaryGridData: any[] = [];
  private salesStatisticDetailGridData: any[] = [];
  private salesStatisticSummaryGrid: any = {};
  private salesStatisticPromotionSummaryGrid: any = {};
  private salesStatisticDetailGrid: any = {};
  private salesStatisticPeriodSummaryGridColumn = ['판매건수', '판매수량', '판매금액', '프로모션할인금액', '적립금사용금액', '배송비',  '외부결제', '총결제금액'];
  private salesStatisticPromotionSummaryGridHeader = ['쇼핑몰부담', '파트너부담'];
  private salesStatisticPromotionSummaryGridColumn = ['프로모션할인금액구분', '할인금액합계', '쇼핑몰할인금액', '쇼핑몰비율', '파트너할인금액', '파트너비율'];
  private salesStatisticPeriodGridColumn = ['일자', '판매건수', '판매수량', '판매금액', '프로모션할인금액', '적립금사용금액', '배송비', '외부결제', '총결제금액'];
  private statisticPage = 1;
  private statisticSize = 100;

  private initGrids(): void {
    this.initSalesStatisticSummaryGrid();
    this.initSalesStatisticPromotionSummaryGrid();
    this.initSalesStatisticDetailGrid();
  }

  private changeStatisticDetailPage(page: any, size?: any) {
    this.statisticPage = page;
    this.statisticSize = size;
    this.getStatisticsSalesPeriod(page, size);
  }

  private initSalesStatisticSummaryGrid() {
    this.salesStatisticSummaryGrid = {
      options: {
        minBodyHeight: 35,
        columnOptions: {
          minWidth: 50
        },
        isInitialRequest: true,
        useClientSort: false,
        scrollX: false,
        scrollY: false
      },
      columns: [],
      onLoadSearch: false
    };
    this.salesStatisticPeriodSummaryGridColumn.forEach((item: any) => {
      let key: any;
      for (key in this.GridsColums) {
        if (item === key) {
          this.salesStatisticSummaryGrid.columns.push(this.GridsColums[key]);
        }
      }
    });
    this.salesStatisticSummaryGrid.columns.push({
      header: '상세보기',
      name: 'excelBtn',
      align: 'center',
      minWidth: 100,
      formatter: (data: any) =>
        `<button type="button" class="excelBtn salesStatisticSummaryExcelBtn" data-start-ymd="${data.row.startYmd}" data-end-ymd="${data.row.endYmd}" data-download-type="ALL"></span>다운로드</button>`
    });
    this.salesStatisticSummaryGrid = i18nInObjectList(this, this.salesStatisticSummaryGrid, 'columns', 'header');
  }
  private initSalesStatisticPromotionSummaryGrid() {
    this.salesStatisticPromotionSummaryGrid = {
      options: {
        columnOptions: {
          minWidth: 50
        },
        isInitialRequest: true,
        useClientSort: false,
        scrollX: false,
        scrollY: false,
        minBodyHeight: 100
      },
      header: {
        height: 68,
        complexColumns: []
      },
      columns: [],
      onLoadSearch: false
    };
    this.salesStatisticPromotionSummaryGridHeader.forEach((item: any) => {
      let key: any;
      for (key in this.GridsColums) {
        if (item === key) {
          this.salesStatisticPromotionSummaryGrid.header.complexColumns.push(this.GridsColums[key]);
        }
      }
    });
    this.salesStatisticPromotionSummaryGridColumn.forEach((item: any) => {
      let key: any;
      for (key in this.GridsColums) {
        if (item === key) {
          this.salesStatisticPromotionSummaryGrid.columns.push(this.GridsColums[key]);
        }
      }
    });
    this.salesStatisticPromotionSummaryGrid.header = i18nInObjectList(this, this.salesStatisticPromotionSummaryGrid.header, 'complexColumns', 'header');
    this.salesStatisticPromotionSummaryGrid = i18nInObjectList(this, this.salesStatisticPromotionSummaryGrid, 'columns', 'header');
  }
  private initSalesStatisticDetailGrid() {
    this.salesStatisticDetailGrid = {
      options: {
        columnOptions: {
          minWidth: 50
        },
        displayRowCount: 30,
        isInitialRequest: true,
        useClientSort: false,
        pageOptions: {
          perPage: 100,
          page: 1,
          totalCount: 0
        }
      },
      columns: []
    };
    this.salesStatisticPeriodGridColumn.forEach((item: any) => {
      let key: any;
      for (key in this.GridsColums) {
        if (item === key) {
          this.salesStatisticDetailGrid.columns.push(this.GridsColums[key]);
        }
      }
    });
    this.salesStatisticDetailGrid.columns.push({
      header: '상세보기',
      name: 'excelBtn',
      align: 'center',
      minWidth: 100,
      formatter: (data: any) =>
        `<button type="button" class="excelBtn salesStatisticDetailExcelBtn" data-start-ymd="${data.row.ymd}" data-end-ymd="${data.row.ymd}" data-download-type="UNIT" data-date-type="PERIOD"></span>다운로드</button>`
    });
    this.salesStatisticDetailGrid = i18nInObjectList(this, this.salesStatisticDetailGrid, 'columns', 'header');
  }
  private getMemberGrades() {
    this.$api
      .getMemberGrades({
        params: {
          mallNo: this.theForm.mallNo
        }
      })
      .then((ret: any) => {
        this.memberGrades = ret.data.filter((ele: any) => ele.used).sort((prev, next) => prev.order - next.order);
      });
  }
  private getMeberGroups() {
    this.$api
      .getMemberGroups({
        params: {
          mallNo: this.theForm.mallNo
        }
      })
      .then((ret: any) => {
        this.memberGroups = ret.data;
      });
  }
  private getPayTypes() {
    const configRequest = {
      pathParams: {
        mallNo: this.theForm.mallNo.toString()
      },
      params: {
        key: 'ORDER_CONFIG'
      }
    };
    this.$api.getMallsConfigurations(configRequest).then((res) => {
      const tempPayTypes = [];
      const enablePayTypes = res.data.enablePayTypes;

      if (enablePayTypes.indexOf('RENTAL') < 0) {
        const mobileTypeIndex = enablePayTypes.indexOf('MOBILE');
        const rentalTypeIndex = mobileTypeIndex < 0 ? enablePayTypes.length : mobileTypeIndex + 1;
        enablePayTypes.splice(rentalTypeIndex, 0, 'RENTAL');
      }

      enablePayTypes.map((item: any) => {
        const pay = this.payTypeMap.find((pay) => pay.value === item)
        if(pay){
          tempPayTypes.push(pay);
        }else{
          // 만에 하나 payType이 없는 경우
          tempPayTypes.push({value: item, name: item});
        }
      });
      this.payTypeArr = tempPayTypes;
    });
  }
  private searchIng = false;
  private genderTypeValidate(): boolean {
    if (this.theForm.genderTypes.join(',') === '') {
      alert(this.$t('VERIFY_MESSAGE_GENDER'));
      return false;
    }
    return true;
  }
  private async search(page: any) {
    if (!this.genderTypeValidate()) return;
    const noData = this.$t('STATISTIC_SALES_PERIOD_SEARCH_NODATA') as string;
    TuiGrid.setLanguage('ko', {
      display: {
        noData
      }
    });
    this.searchIng = true;
    this.$nextTick(async () => {
      this.searchIng = false;
      await this.getStatisticsSalesPeriod(page);
      await this.getStatisticsSalesPeriodSummary(page);
    });
  }

  private getStatisticsSalesPeriodParams(page, size) {
    return {
      page,
      size: size ? size : this.salesStatisticDetailGrid.options.pageOptions.perPage,
      mallNo: this.theForm.mallNo,
      memberType: this.theForm.memberType,
      genderTypes: this.theForm.genderTypes.join(','),
      memberGradeNo: this.theForm.memberGradeNo,
      memberGroupNo: this.theForm.memberGroupNo,
      platformTypes: this.theForm.platformTypes.join(','),
      includesClaim: String(this.theForm.includesClaim),
      payType: this.theForm.payType,
      endYmd: this.theForm.dateType === 'MONTH' ? getFirstAndEndDay(this.theForm.year, this.theForm.month).endYmd : this.endYmdt,
      startYmd: this.theForm.dateType === 'MONTH' ? getFirstAndEndDay(this.theForm.year, this.theForm.month).startYmd : this.startYmdt
    }
  }

  private get statisticsDetailExtraInfo() {
    const startYmd = this.theForm.dateType === 'MONTH' ? getFirstAndEndDay(this.theForm.year, this.theForm.month).startYmd : this.startYmdt;
    const endYmd = this.theForm.dateType === 'MONTH' ? getFirstAndEndDay(this.theForm.year, this.theForm.month).endYmd : this.endYmdt;

    return `${changeDateFormat(startYmd, 'YYYYMMDD')}_${changeDateFormat(endYmd, 'YYYYMMDD')}`
  }

  private getStatisticsSalesPeriod(page: any, size?: any) {
    return new Promise((resolve: any): void => {
      this.$api.getStatisticsSalesPeriod({params: this.getStatisticsSalesPeriodParams(page, size)}).then((res: any) => {
        this.salesStatisticDetailGridData = res.data.contents;
        this.salesStatisticDetailGrid.options.pageOptions.totalCount = res.data.totalCount;
        this.salesStatisticDetailGrid.options.pageOptions.perPage = size ? size : (this.$refs.theGrid as any).itemInfo.pageSize;
        this.salesStatisticDetailGrid.options.pageOptions.page = page;
        resolve();
      });
    });
  }
  private getStatisticsSalesPeriodSummary(page: any) {
    const obj = {
      params: {
        page,
        size: String(this.pageSize),
        mallNo: this.theForm.mallNo,
        memberType: this.theForm.memberType,
        genderTypes: this.theForm.genderTypes.join(','),
        memberGradeNo: this.theForm.memberGradeNo,
        memberGroupNo: this.theForm.memberGroupNo,
        platformTypes: this.theForm.platformTypes.join(','),
        includesClaim: String(this.theForm.includesClaim),
        payType: this.theForm.payType,
        endYmd: this.theForm.dateType === 'MONTH' ? getFirstAndEndDay(this.theForm.year, this.theForm.month).endYmd : this.endYmdt,
        startYmd: this.theForm.dateType === 'MONTH' ? getFirstAndEndDay(this.theForm.year, this.theForm.month).startYmd : this.startYmdt
      }
    };
    this.$api.getStatisticsSalesPeriodSummary(obj).then((res: any) => {
      this.tableFormLeft = res.data.startYmd + ' ~ ' + res.data.endYmd;
      this.tableFormRight = (this.mallsArr.find((item) => item.mallNo === Number(res.data.mallNo)) as any).mallName;
      res.data.summary.startYmd = res.data.startYmd;
      res.data.summary.endYmd = res.data.endYmd;
      res.data.summary.currencyCode = res.data.currencyCode;
      this.salesStatisticSummaryGridData = [res.data.summary];
      this.salesStatisticPromotionSummaryGridData = [...this.createPromotionSummaryData(res.data.promotionSummary, res.data.currencyCode)];
    });
  }

  private createPromotionSummaryData(currentData: any, currencyCode: string) {
    if (this.salesStatisticDetailGridData.length == 0) {
      this.resetSummaryGridData();
      return [];
    }

    const totalCount = currentData.totalAdditionalDiscountAmt + currentData.totalProductCouponAmt + currentData.totalFreeGiftAmt + currentData.totalCartCouponAmt;
    const totalMallDiscountAmt = currentData.totalMallAdditionalDiscountAmt + currentData.totalMallProductCouponAmt + currentData.totalMallFreeGiftAmt + currentData.totalCartCouponAmt;

    // 장바구니 할인금액은 무조건 몰 부담
    const totalPartnerDiscountAmt = currentData.totalPartnerAdditionalDiscountAmt + currentData.totalPartnerProductCouponAmt + currentData.totalPartnerFreeGiftAmt;

    const theDataArr = [
      {
        promotionType: '소계',
        totalPromotionAmt: totalCount,
        totalMallDiscountAmt: totalMallDiscountAmt,
        mallDiscountRate: this.calculateDiscountRate(totalCount, totalMallDiscountAmt),
        totalPartnerDiscountAmt: totalPartnerDiscountAmt,
        partnerDiscountRate: this.calculateDiscountRate(totalCount, totalPartnerDiscountAmt),
        currencyCode,
      },
      {
        promotionType: '추가할인',
        totalPromotionAmt: currentData.totalAdditionalDiscountAmt,
        totalMallDiscountAmt: currentData.totalMallAdditionalDiscountAmt,
        mallDiscountRate: this.calculateDiscountRate(currentData.totalAdditionalDiscountAmt, currentData.totalMallAdditionalDiscountAmt),
        totalPartnerDiscountAmt: currentData.totalPartnerAdditionalDiscountAmt,
        partnerDiscountRate: this.calculateDiscountRate(currentData.totalAdditionalDiscountAmt, currentData.totalPartnerAdditionalDiscountAmt),
        currencyCode,
      },
      {
        promotionType: '상품금액할인',
        totalPromotionAmt: currentData.totalProductCouponAmt,
        totalMallDiscountAmt: currentData.totalMallProductCouponAmt,
        mallDiscountRate: this.calculateDiscountRate(currentData.totalProductCouponAmt, currentData.totalMallProductCouponAmt),
        totalPartnerDiscountAmt: currentData.totalPartnerProductCouponAmt,
        partnerDiscountRate: this.calculateDiscountRate(currentData.totalProductCouponAmt, currentData.totalPartnerProductCouponAmt),
        currencyCode,
      },
      {
        promotionType: '사은품할인',
        totalPromotionAmt: currentData.totalFreeGiftAmt,
        totalMallDiscountAmt: currentData.totalMallFreeGiftAmt,
        mallDiscountRate: this.calculateDiscountRate(currentData.totalFreeGiftAmt, currentData.totalMallFreeGiftAmt),
        totalPartnerDiscountAmt: currentData.totalPartnerFreeGiftAmt,
        partnerDiscountRate: this.calculateDiscountRate(currentData.totalFreeGiftAmt, currentData.totalPartnerFreeGiftAmt),
        currencyCode,
      },
      {
        promotionType: '장바구니금액할인',
        totalPromotionAmt: currentData.totalCartCouponAmt,
        totalMallDiscountAmt: currentData.totalCartCouponAmt,
        mallDiscountRate: currentData.totalCartCouponAmt > 0 ? 100 : 0,
        totalPartnerDiscountAmt: 0,
        partnerDiscountRate: 0,
        currencyCode,
      }
    ];
    return theDataArr;
  }

  private resetSummaryGridData() {
    this.salesStatisticPromotionSummaryGridData = [];
  }

  private calculateDiscountRate(totalAmt: number, totalMallAmt: number): number {
    return totalAmt === 0 ? 0 : (totalMallAmt / totalAmt) * 100
  }

  private onClickTabMenu(urlPath: string) {
    if (this.$route.path === urlPath) {
      this.$router.go(0);
      return;
    }

    this.$router.push({
      path: urlPath
    });
  }
  private async changeMall() {
    this.theForm.memberGradeNo = '0';
    this.theForm.memberGroupNo = '0';
    this.theForm.payType = '';
    this.getMemberGrades();
    this.getMeberGroups();
    this.getPayTypes();
    await this.$api.getStatisticsMemberTypes({params: {mallNo: this.theForm.mallNo.toString()}}).then((ret) => {
      const {data} = ret;
      this.memberTypeList = [];
      data.forEach((item) => {
        const temp = {
          value: '',
          name: ''
        };
        temp.value = item.type;
        temp.name = item.label;
        this.memberTypeList.push(temp);
      });
    });
  }
  private resetAll() {
    this.theForm = {
      mallNo: this.$store.getters['mall/malls'][0].mallNo,
      memberType: 'ALL',
      genderTypes: ['MALE', 'FEMALE', 'UNKNOWN'],
      memberGradeNo: '0',
      memberGroupNo: '0',
      platformTypes: ['PC', 'MOBILE_WEB', 'MOBILE_APP'],
      includesClaim: false,
      payType: '',
      dateType: 'MONTH',
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1
    };
    const tempVue: any = this.$refs.datePicker;
    tempVue.clickPeriod('1m');
  }
  downloadExcel(e: any) {
    if (!this.genderTypeValidate()) return;
    const startYmd = $(e.target).data('startYmd');
    const endYmd = $(e.target).data('endYmd');

    const excelDownRequest: GetStatisticsExcelRequest = {
      params: {
        couponType: '',
        endYmd: endYmd,
        genderTypes: this.theForm.genderTypes.join(','),
        includesClaim: String(this.theForm.includesClaim),
        keyword: '',
        mallNo: String(this.theForm.mallNo),
        memberGradeNo: this.theForm.memberGradeNo,
        memberGroupNo: this.theForm.memberGroupNo,
        memberType: this.theForm.memberType,
        page: String(1),
        payType: this.theForm.payType,
        platformTypes: this.theForm.platformTypes.join(','),
        promotionKeywordType: '',
        promotionType: '',
        size: this.pageSize ? String(this.pageSize) : String((this.$refs.theGrid as any).itemInfo.pageSize),
        startYmd: startYmd
      }
    };

    if($(e.target).data('downloadType') === 'ALL') {
      createExcel(this, this.salesStatisticDetailGridData.length > 0, excelDownRequest.params, 'PREMIUM_STATISTICS_SALE_PERIOD', `${startYmd.replace(/-/g, '')}_${endYmd.replace(/-/g, '')}`);
    } else {
      createExcel(this, this.salesStatisticDetailGridData.length > 0, excelDownRequest.params, 'PREMIUM_STATISTICS_SALE_PERIOD_DAILY', `${startYmd.replace(/-/g, '')}_${endYmd.replace(/-/g, '')}`);
    }



    // this.$api.getStatisticsExcel(excelDownRequest).then((res) => {
    //   const blob = new window.Blob([res.data], {type: 'blob'});
    //   if ('download' in document.createElement('a')) {
    //     // 非IE下载
    //     const elink = document.createElement('a');
    //     elink.download = fileName;
    //     elink.style.display = 'none';
    //     elink.href = URL.createObjectURL(blob);
    //     document.body.appendChild(elink);
    //     elink.click();
    //     URL.revokeObjectURL(elink.href); // 释放URL 对象
    //     document.body.removeChild(elink);
    //   } else {
    //     // IE10+下载
    //     navigator.msSaveBlob(blob, fileName);
    //   }
    // });

    // this.checkExcelComplete();
  }
  private changeQueryString(qs: any, param: any, value: any) {
    const reg = new RegExp(`([?|&])${param}=.*?(&|$)`, 'i');
    if (qs.match(reg)) {
      qs = qs.replace(reg, `$1${param}=${value}$2`);
    }

    return qs;
  }
  private checkExcelComplete() {
    if (getCookie('fileDownload') === 'true') {
      setCookie('fileDownload', 'false');
    } else {
      setTimeout(this.checkExcelComplete, 1000);
    }
  }
  private memberTypeList: {
    value: string;
    name: string;
  }[] = [];
  private async created() {
    const noData = this.$t('STATISTIC_SALES_PERIOD_INIT_NODATA') as string;
    TuiGrid.setLanguage('ko', {
      display: {
        noData
      }
    });
    this.initGrids();
    await this.$api.getStatisticsMemberTypes({params: {mallNo: this.theForm.mallNo.toString()}}).then((ret) => {
      const {data} = ret;
      data.forEach((item) => {
        const temp = {
          value: '',
          name: ''
        };
        temp.value = item.type;
        temp.name = item.label;
        this.memberTypeList.push(temp);
      });
    });
  }
  private mounted() {
    this.getMemberGrades();
    this.getMeberGroups();
    this.getPayTypes();
    $('body').on('click', '.salesStatisticSummaryExcelBtn', $.proxy(this.downloadExcel, this));
    $('body').on('click', '.salesStatisticDetailExcelBtn', $.proxy(this.downloadExcel, this));
  }
  protected beforeDestroy(): void {
    $('body').off('click', '.salesStatisticSummaryExcelBtn', $.proxy(this.downloadExcel, this));
    $('body').off('click', '.salesStatisticDetailExcelBtn', $.proxy(this.downloadExcel, this));
  }
}
